import { TEXT_ANNOTATION_TYPE } from 'src/data/annotation';

export const shouldBeDisplayedAsList = (annotationType) =>
  [TEXT_ANNOTATION_TYPE.features, TEXT_ANNOTATION_TYPE.benefits].includes(annotationType);

export const getAnnotationHint = (annotationType) => {
  switch (annotationType) {
    case TEXT_ANNOTATION_TYPE.features:
      return 'Generate more variations highlighting this feature.';
    case TEXT_ANNOTATION_TYPE.benefits:
      return 'Generate more variations highlighting this benefit.';
    default:
      return null;
  }
};
